document.addEventListener('DOMContentLoaded', () => {
        function getSearchDialog() {
          return (
            document.querySelector('dialog.dialog-modal.search-modal__content') 
          );
        }

        // 1. NATIVE CLOSING ENGINE: Force-closes the HTML5 dialog
        function closeSearchaniseDialog(dialogEl) {
          if (dialogEl && dialogEl.hasAttribute('open')) {
            dialogEl.close(); // Native browser close command

            // Clean up our native listeners so they don't stack up up in memory
            dialogEl.removeEventListener('click', handleOutsideClick);
            dialogEl.removeEventListener('cancel', handleNativeEscape);
          }
        }

        // 3. NATIVE OUTSIDE CLICK HANDLER: Calculates coordinates on the backdrop
        function handleOutsideClick(e) {
          const dialog = e.target;
          // In HTML5 <dialog>, clicking the dark backdrop targets the <dialog> itself.
          // We check if the click coordinates fall outside the inner content box bounds.
          if (e.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            const clickedInside =
              rect.top <= e.clientY &&
              e.clientY <= rect.top + rect.height &&
              rect.left <= e.clientX &&
              e.clientX <= rect.left + rect.width;

            if (!clickedInside) {
              closeSearchaniseDialog(dialog);
            }
          }
        }

        function openSearchaniseSystem(e) {
          if (e) e.preventDefault();
          const snizeDialog = getSearchDialog();

          if (snizeDialog) {
            if (!snizeDialog.hasAttribute('open') || snizeDialog.getAttribute('open') === 'false') {
              // Use the native browser API to trigger the modal layout open cleanly
              if (typeof snizeDialog.showModal === 'function') {
                snizeDialog.showModal();
              } else {
                snizeDialog.setAttribute('open', 'true');
              }

              snizeDialog.addEventListener('click', handleOutsideClick);
            }
          }
        }

        document.addEventListener('keydown', (e) => {
          const snizeDialog = getSearchDialog();
          const isDialogOpen = snizeDialog && snizeDialog.hasAttribute('open');
          if (e.key === 'Escape' && isDialogOpen) {
            e.preventDefault();
            closeSearchaniseDialog(snizeDialog);
            return;
          }
          if (
            ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName) ||
            document.activeElement.isContentEditable
          ) {
            return;
          }

          if (e.key === 'F4') {
            openSearchaniseSystem(e);
          }
        });
      });
